import partition from 'lodash/partition'
import sortBy from 'lodash/sortBy'
import type { FC } from 'react'
import { useEffect, useState } from 'react'
import { memo } from 'react'

import type { ChakraReactSelectProps } from '@app/shared/autocomplete/chakraAutocompletes'
import { ChakraReactSelect } from '@app/shared/autocomplete/chakraAutocompletes'
import withSuspenseWrapper from '@app/shared/withSuspenseWrapper'
import { useOrganizationsQuery } from '@graphql/queries'

type Option = {
  name: string
  slug: string
}

type Props = ChakraReactSelectProps<Option, false>

const formatOptionLabel: Props['formatOptionLabel'] = (o) => o.name
const getOptionLabel: Props['getOptionLabel'] = (o) => o.name
const getOptionValue: Props['getOptionValue'] = (o) => o.slug

const OrganizationsSelect: FC<Props> = (props) => {
  const [options, setOptions] = useState<Option[]>([])

  const [result] = useOrganizationsQuery({
    pause: options.length > 0
  })

  useEffect(() => {
    const [dl, nonDl] = partition(result?.data?.organizations || [], (o) => o.slug === 'doubleloop')
    const opts = [...dl, ...sortBy(nonDl, 'name')]
    setOptions(opts)
  }, [result])

  return (
    <ChakraReactSelect<Option, false>
      options={options}
      isSearchable
      isLoading={result?.fetching}
      formatOptionLabel={formatOptionLabel}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      {...props}
    />
  )
}

export default memo(withSuspenseWrapper(OrganizationsSelect))
